module.exports = __webpack_public_path__ + "static/media/logo-loyola-300x300.f2c037d5.svg";